import { AddIntegration } from './AddIntegration';

export default AddIntegration;